import { Controller } from "stimulus"

export default class extends Controller {
  toggle() {
    const input = this.element.querySelector('input[type="password"], input[type="text"]')
    const icon = this.element.querySelector('em')

    input.type = input.type === 'password' ? 'text' : 'password'
    icon.classList.toggle('fa-eye')
    icon.classList.toggle('fa-eye-slash')
  }
}
